import React, { useEffect, useState } from "react";
import { getGeo } from "../lib/geo";

const isBlocked = (geo) =>
  geo && (geo.country_code === "PL" || geo.country === "Poland");

/* Region gate — site is not served to blocked regions */
export const GeoGate = ({ children }) => {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    getGeo().then((geo) => {
      if (isBlocked(geo)) setBlocked(true);
    });
  }, []);

  if (blocked) {
    return (
      <main
        className="min-h-screen bg-[#050b1c] text-zinc-100 flex items-center justify-center px-6"
        data-testid="geo-blocked-screen"
      >
        <div className="text-center max-w-md">
          <div className="font-display text-2xl text-zinc-100">Service unavailable</div>
          <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
            This website is not available in your region.
          </p>
        </div>
      </main>
    );
  }
  return children;
};

export default GeoGate;
